import { Button, Input, Form, Typography, Flex, notification } from "antd";

import { useState } from "react";
import { useAuth } from "../../providers/AuthProvider";
const { Title } = Typography;

export const Settings = () => {
  const [isFormValid, setIsFormValid] = useState(false);
  const [form] = Form.useForm();
  const { onPasswordChange } = useAuth();

  const passwordChange = () => {
    const { currentPassword, newPassword } = form.getFieldsValue();
    onPasswordChange({ password: currentPassword, newPassword })
      .then((res: { data: { success: boolean } }) => {
        if (res.data.success) {
          notification.open({
            type: "success",
            message: "Success!",
            description: "Password has been changed",
          });
          form.resetFields();
        }
      })
      .catch((err) => {
        if (
          err.response.status === 400 &&
          err.response.data.message === "Invalid password"
        ) {
          notification.open({
            type: "error",
            message: "Error!",
            description: "Provided password is invalid",
          });
          return;
        }
        notification.open({
          type: "error",
          message: "Error!",
          description: "Something went wrong",
        });
        return;
      });
  };

  const validatePassword = (rule: unknown, value: string) => {
    const errors = [];

    if (!value) {
      errors.push("Provide new password");
    }
    if (value && value.length < 10) {
      errors.push("Password must be at least 10 characters long"); // Password must be at least 10 characters long!
    }
    if (value && value.length > 32) {
      errors.push("Password can be at most 32 characters long!"); // Password can be at most 32 characters long!
    }
    if (value && !/[0-9]/.test(value)) {
      errors.push("Password must contain at least one digit (0-9)!"); // Password must contain at least one digit (0-9)!
    }
    if (value && !/[a-zA-Z]/.test(value)) {
      errors.push("Password must contain at least one letter (a-z, A-Z)!"); // Password must contain at least one letter (a-z, A-Z)!
    }
    if (value && !/[!@#$%^&*(), .?":{}|<>'/`;\-=+~\\]/.test(value)) {
      errors.push(
        'Password must contain at least one special character (!@#$%^&*(),.?":{}|<>)',
      ); // Password must contain at least one special character (!@#$%^&*(),.?":{}|<>)
    }

    if (errors.length) {
      return Promise.reject(errors);
    }

    return Promise.resolve();
  };

  const handleValuesChange = () => {
    setTimeout(() => {
      // this setTimeout is needed in order for password confirm to work
      // because handleValuesChange is called before the confirm password function returns true
      const isValid =
        form.isFieldsTouched(true) &&
        !form.getFieldsError().some(({ errors }) => errors.length);
      setIsFormValid(isValid);
    }, 0);
  };

  return (
    <Flex vertical align="center">
      <Flex vertical align="center" justify="center" style={{ marginTop: 20 }}>
        <Title style={{ marginBottom: 20 }} level={3}>
          Settings
        </Title>
      </Flex>
      <Form
        form={form}
        layout="vertical"
        onFinish={passwordChange}
        onFinishFailed={() => console.log("failed")}
        onValuesChange={handleValuesChange}
        autoComplete="off"
        style={{ width: "400px", padding: "0px 20px", borderRadius: "8px" }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Typography.Title level={5}>Change password</Typography.Title>
        </div>

        <Form.Item
          name="currentPassword"
          rules={[
            {
              required: true,
              message: "Provide current password",
            },
          ]}
        >
          <Input.Password placeholder="Current password" />
        </Form.Item>

        <Form.Item name="newPassword" rules={[{ validator: validatePassword }]}>
          <Input.Password placeholder={"New password"} />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          dependencies={["newPassword"]}
          rules={[
            {
              required: true,
              message: "Confirm new password",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const newPassword = getFieldValue("newPassword");
                if (!value || newPassword === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Provided passwords do not match"),
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm new password" />
        </Form.Item>

        <Form.Item>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button type="primary" htmlType="submit" disabled={!isFormValid}>
              Change password
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Flex>
  );
};

export default Settings;
